import React, { memo, useContext } from "react";
import { EditorContext } from "../contexts/EditorContext.js";
import { CustomNodeView } from "./CustomNodeView.js";
import { ReactNodeView } from "./ReactNodeView.js";
export const NodeView = /*#__PURE__*/ memo(function NodeView(param) {
    let { outerDeco, getPos, node, innerDeco, ...props } = param;
    const { view } = useContext(EditorContext);
    const customNodeView = view?.someProp("nodeViews", (nodeViews)=>nodeViews?.[node.type.name]);
    if (customNodeView) {
        return /*#__PURE__*/ React.createElement(CustomNodeView, {
            customNodeView: customNodeView,
            node: node,
            innerDeco: innerDeco,
            outerDeco: outerDeco,
            getPos: getPos
        });
    }
    return /*#__PURE__*/ React.createElement(ReactNodeView, {
        node: node,
        innerDeco: innerDeco,
        outerDeco: outerDeco,
        getPos: getPos,
        ...props
    });
});
